/* MP Artshop — conversion fixes — rev. 13.09.2026 (scroll fix)

   WHAT CHANGED AND WHY
   The previous revision ran reorderGrids() from a MutationObserver watching
   document.body with subtree:true. Re-appending product tiles is itself a DOM
   mutation, and the theme's own list components re-render in response, so the
   observer kept re-triggering itself. The page was rebuilt continuously, which
   reset scroll position on desktop — the page could not be scrolled down.

   The observer is gone. Everything now runs on explicit events only:
   once at load, and again when the cart changes or a new page is shown.
*/
(function () {
  var FREE_SHIPPING_THRESHOLD = 500; // DH
  var SOLD_OUT_WORDS = ['epuis', 'épuis', 'sold out', 'rupture', 'indisponible'];
  var SALE_SELECTOR = 's, del, [class*="compare"], [class*="on-sale"], [class*="sale-price"], [class*="badge--sale"]';

  /* ---------- 1. Order product grids: promotions first, sold-out last ---------- */
  /* Runs once per page load. No live re-sorting: items added later by infinite
     scroll keep their natural order rather than restarting the loop above. */

  function classify(item) {
    var text = (item.textContent || '').toLowerCase();
    var soldOut = SOLD_OUT_WORDS.some(function (w) { return text.indexOf(w) > -1; });
    if (soldOut) return 'sold';
    var onSale = item.querySelector(SALE_SELECTOR) ||
                 text.indexOf('solde') > -1 ||
                 text.indexOf('promo') > -1;
    return onSale ? 'promo' : 'normal';
  }

  function groupsOfProductItems() {
    var groups = new Map();
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var item = a.closest('li') || a.closest('[class*="grid__item"]') || a.closest('[class*="card"]');
      if (!item || !item.parentElement) return;
      var parent = item.parentElement;
      if (!groups.has(parent)) groups.set(parent, []);
      var list = groups.get(parent);
      if (list.indexOf(item) === -1) list.push(item);
    });
    return groups;
  }

  var reordered = false;

  function reorderGrids() {
    if (reordered) return;
    reordered = true;

    groupsOfProductItems().forEach(function (items, parent) {
      if (items.length < 3) return;

      /* Horizontal carousels manage their own scroll offsets; moving their
         children breaks the measurement. Leave them alone. */
      if (parent.closest('[part="list"], overflow-list, slideshow-component, .carousel')) return;

      var promos = [], normals = [], solds = [];
      items.forEach(function (item) {
        var kind = classify(item);
        item.removeAttribute('data-mp-promo');
        item.removeAttribute('data-mp-sunk');
        if (kind === 'sold') { item.setAttribute('data-mp-sunk', '1'); solds.push(item); }
        else if (kind === 'promo') { item.setAttribute('data-mp-promo', '1'); promos.push(item); }
        else { normals.push(item); }
      });

      var desired = promos.concat(normals, solds);

      var current = items.slice().sort(function (a, b) {
        return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
      });
      var same = desired.every(function (el, i) { return current[i] === el; });
      if (same) return;

      var frag = document.createDocumentFragment();
      desired.forEach(function (el) { frag.appendChild(el); });
      parent.appendChild(frag);
    });
  }

  /* ---------- 2. Mark the filter bar so CSS can pin it ---------- */
  function markFilterBar() {
    if (document.querySelector('[data-mp-filterbar]')) return;
    var candidates = document.querySelectorAll('button, summary, label');
    for (var i = 0; i < candidates.length; i++) {
      var t = (candidates[i].textContent || '').trim().toLowerCase();
      if (t === 'filtrer' || t === 'filter') {
        var bar = candidates[i].closest('[class*="facet"]') ||
                  candidates[i].closest('[class*="filter"]') ||
                  candidates[i].parentElement;
        if (bar) { bar.setAttribute('data-mp-filterbar', '1'); }
        return;
      }
    }
  }

  function handleScroll() {
    document.documentElement.classList.toggle('mp-scrolled', window.scrollY > 40);
  }

  /* ---------- 3. Free shipping progress bar ---------- */
  var shipBarBusy = false;

  function barMarkup(total) {
    var remaining = FREE_SHIPPING_THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100));
    var done = remaining <= 0;
    var message = done
      ? 'Bravo — votre livraison est offerte.'
      : 'Plus que <strong>' + Math.ceil(remaining) + ' DH</strong> pour la livraison gratuite.';
    return '<div class="mp-shipbar' + (done ? ' mp-shipbar--done' : '') + '" data-mp-shipbar>' +
      '<p class="mp-shipbar__text">' + message + '</p>' +
      '<span class="mp-shipbar__track"><span class="mp-shipbar__fill" style="width:' + pct + '%"></span></span>' +
      '</div>';
  }

  function mountShipBar() {
    if (shipBarBusy) return;
    shipBarBusy = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.total_price !== 'number') return;

        if (cart.item_count === 0) {
          document.querySelectorAll('[data-mp-shipbar]').forEach(function (n) { n.remove(); });
          return;
        }

        var html = barMarkup(cart.total_price / 100);

        var hosts = [
          document.querySelector('cart-drawer .drawer__inner'),
          document.querySelector('cart-drawer'),
          document.querySelector('#cart-drawer'),
          document.querySelector('.cart__items'),
          document.querySelector('cart-items'),
          document.querySelector('main .cart')
        ].filter(Boolean);

        hosts.forEach(function (host) {
          var existing = host.querySelector(':scope > [data-mp-shipbar]');
          if (existing) { existing.outerHTML = html; }
          else { host.insertAdjacentHTML('afterbegin', html); }
        });
      })
      .catch(function () {})
      .finally(function () { shipBarBusy = false; });
  }

  /* ---------- 4. Wire up ---------- */
  function runOnce() {
    reorderGrids();
    markFilterBar();
    mountShipBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runOnce);
  } else {
    runOnce();
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  /* Cart changes: refresh the bar only — never the grids. */
  var shipBarTimer = null;
  function scheduleShipBar() {
    clearTimeout(shipBarTimer);
    shipBarTimer = setTimeout(mountShipBar, 400);
  }

  document.addEventListener('cart:updated', scheduleShipBar);
  document.addEventListener('cart:refresh', scheduleShipBar);
  document.addEventListener('click', function (e) {
    if (e.target.closest('button[name="add"], quick-add-component, .add-to-cart, [data-testid="cart-drawer-trigger"]')) {
      scheduleShipBar();
    }
  });
  window.addEventListener('pageshow', scheduleShipBar);
})();
